import cfg from 'client/common/utils/client-config';
import {getSurvey} from 'client/common/utils/api-client';

import {CreativesBoxType} from '../types';

export async function fetchCreativeDemoSurveys(surveyType: CreativesBoxType) {
    const slugs = cfg.demoSlugs[surveyType];
    const surveys = [];

    for (const slug of slugs) {
        const {data, status} = await getSurvey({slug, apiLocation: 'survey'});

        if (status === 200) {
            surveys.push(data);
        }
    }

    return surveys;
}
